import React, { memo } from 'react';
import NewClassLevel from './Config/ClassLevel/NewClassLevel';
import EditClassLevel from './Config/ClassLevel/EditClassLevel';
import NewClassRoom from './Config/Classes/NewClassRoom';
import EditClassRoom from './Config/Classes/EditClassRoom';
import NewStream from './Config/Classes/NewStream';
import ManageStreams from './Config/Classes/ManageStreams';
import EditStream from './Config/Classes/EditStream';
import NewSubject from './Config/Subjects/NewSubject';
import ManageSubject from './Config/Subjects/ManageSubject';
import NewTerm from './Config/Term/NewTerm';
import EditTerm from './Config/Term/EditTerm';
import NewExam from './Config/Exams/NewExam';
import EditExam from './Config/Exams/EditExam';
import SetCurrentPeriod from './Config/Exams/SetCurrentPeriod';
import SetCurrentExam from './Config/Exams/SetCurrentExam';
import NewHouse from './Config/House/NewHouse';
import EditHouse from './Config/House/EditHouse';
import NewReport from './Academics/Reports/NewReport';
import ReportProperties from './Academics/Reports/ReportProperties';
import EditReport from './Academics/Reports/EditReport';
import EditSchoolProfile from './Config/Profile/EditSchoolProfile';
import UploadBadge from './Config/Profile/UploadBadge';
import UploadSignature from './Config/Profile/UploadSignature';
import NewContact from './Student/NewContact';
import EditContact from './Student/EditContact';
import NewFile from './Student/NewFile';
import ReportComments from './Academics/Reports/ReportComments';
import NewComment from './Config/Report/NewComment';
import EditComment from './Config/Report/EditComment';
import ChangeStudentPhoto from './Student/ChangeStudentPhoto';
import AssignSubject from './Staff/AssignSubject';
import StaffAccessConfig from './Staff/StaffAccessConfig';
import NewRole from './Config/Role/NewRole';
import UpdateRole from './Config/Role/UpdateRole';
import NewUserInvite from './Config/User/NewUserInvite';
import EditInterface from './Config/ExternalInterface/EditInterface';
import SyncBalances from './Fees/SyncBalances';
import SetMarksInitials from './Academics/Reports/SetMarksInitials';
import MarksCopier from './Academics/MarksEntry/MarksCopier';


const Container = ({ settingsOpen, closeSettings, settingTitle, children }) => (
    <div className={`ui-theme-settings ${settingsOpen ? 'settings-open' : ''}`}>
        <div className="theme-settings__inner right-sidebar">
            <div className="scrollbar-container ps ps--active-y">
                <div className="theme-settings__options-wrapper">
                    <h3 className="themeoptions-heading">
                        <div>{settingTitle}</div>
                        <button
                            type="button"
                            className="btn-pill btn-shadow btn-wide ml-auto btn btn-focus btn-sm switch-header-cs-class"
                            onClick={closeSettings}
                        >
                            Close
                        </button>
                    </h3>
                    <div className="p-0 overflow-auto" style={{ maxHeight: '95vh', height: '95vh' }}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    </div>
);

const componentMapping = {
    NewClassLevel: NewClassLevel,
    EditClassLevel: ({ settingData }) => <EditClassLevel levelInfo={settingData} />,
    ConfigNewClass: NewClassRoom,
    ConfigEditClass: ({ settingData }) => <EditClassRoom classInfo={settingData} />,
    ConfigNewStream: ({ settingData }) => <NewStream classInfo={settingData} />,
    ManageStreams: ({ settingData }) => <ManageStreams classInfo={settingData} />,
    EditStream: ({ settingData }) => <EditStream streamInfo={settingData} />,
    ConfigNewSubject: NewSubject,
    ConfigManageSubject: ({ settingData }) => <ManageSubject subjectInfo={settingData} />,
    NewAcademicTerm: NewTerm,
    EditAcademicTerm: ({ settingData }) => <EditTerm termInfo={settingData} />,
    ConfigNewAssessment: NewExam,
    ConfigEditAssessment: ({ settingData }) => <EditExam examInfo={settingData} />,
    ConfigSetCurrentPeriod : SetCurrentPeriod,
    SetClassExam: ({ settingData }) => <SetCurrentExam classExamInfo={settingData} />,
    NewHouse: NewHouse,
    EditHouse: ({ settingData }) => <EditHouse houseInfo={settingData} />,
    NewReport: NewReport,
    ReportProperties: ({ settingData }) => <ReportProperties reportInfo={settingData} />,
    EditReport: ({ settingData }) => <EditReport reportInfo={settingData} />,
    EditSchoolProfile: ({ settingData }) => <EditSchoolProfile schoolProfile={settingData} />,
    UploadBadge: UploadBadge,
    UploadSignature: UploadSignature,
    NewStudentContact: ({ settingData }) => <NewContact studentHandler={settingData} />,
    EditStudentContact: ({ settingData }) => <EditContact contact={settingData} studentHandler={settingData.studentHandler} />,
    NewStudentFile: ({ settingData }) => <NewFile studentId={settingData} />,
    ReportComment: ({ settingData }) => <ReportComments reportInfo={settingData} />,
    ConfigNewComment: NewComment,
    ConfigEditComment: ({ settingData }) => <EditComment commentInfo={settingData} />,
    NewStudenPhoto: ({ settingData }) => <ChangeStudentPhoto studentId={settingData} />,
    AssignStaffSubject: ({ settingData }) => <AssignSubject teacherId={settingData} />,
    StaffAccessConfig: ({ settingData }) => <StaffAccessConfig teacherId={settingData} />,
    ConfigNewUserRole: NewRole,
    ConfigEditUserRole: ({ settingData }) => <UpdateRole role={settingData} />,
    ConfigNewUser: NewUserInvite,
    ConfigInterface: ({ settingData }) => <EditInterface extInterface={settingData} />,
    SyncFeesBalances: () => <SyncBalances />,
    SetMarksInitials: ({ settingData }) => <SetMarksInitials reportId={settingData.reportId} paperId={settingData.paperId} />,
    CopyMarks: MarksCopier,

}



const RightSideBar = memo(({ settingsOpen, closeSettings, settingTitle, settingCode, settingData }) => {
    const SelectedComponent = componentMapping[settingCode];

    return SelectedComponent ? (
        <Container settingsOpen={settingsOpen} closeSettings={closeSettings} settingTitle={settingTitle}>
            {typeof SelectedComponent === 'function' ? <SelectedComponent settingData={settingData} /> : <SelectedComponent />}
        </Container>
    ) : null;
});

export default RightSideBar;
